import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import Actions from 'Actions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import AdvocacyLandingEN from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacyLanding/locales/AdvocacyLanding_en_US';
import AdvocacyLandingFR from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacyLanding/locales/AdvocacyLanding_fr_CA';

const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(AdvocacyLandingEN, AdvocacyLandingFR);

const { wrapHOC } = FrameworkUtils;
const { showSignInModal, showBiRegisterModal, showRegisterModal } = Actions;

const localization = createStructuredSelector({
    joinNow: getTextFromResource(getText, 'joinNow'),
    createAccount: getTextFromResource(getText, 'createAccount'),
    signIn: getTextFromResource(getText, 'signIn')
});

const fields = createSelector(userSelector, localization, (user, locales) => {
    return {
        user,
        locales
    };
});

const functions = {
    showSignInModal,
    showBiRegisterModal,
    showRegisterModal
};

const withAdvocacyLandingProps = wrapHOC(connect(fields, functions));

export {
    withAdvocacyLandingProps, fields, functions
};
